import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

export default function AmountPayDueMOB({ isOpen, closefun, children}) {
  return (
    <BottomSheet
      open={isOpen}
      onDismiss={closefun} // Close on overlay click or swipe down
      // blocking={false} // Allows closing by clicking outside
      skipInitialTransition // Prevent bounce on first render
      scrollLocking={false} // Prevent bounce on scroll
    >
     {children}
    </BottomSheet>
  );
}
